import { useSearchParams } from "react-router-dom";

export type AdminContextResult = {
    adminTenantId: string | null;
    adminSuscriptionId: string | null;
    isAdminMode: boolean;
    /** Suffix de query params para agregar a hrefs de subpáginas */
    adminQuerySuffix: string;
    profileBackUrl: string;
};

/**
 * Devuelve el contexto admin cuando el super admin está editando
 * la suscripción de otro tenant (URL incluye ?tenantId y ?suscriptionId).
 */
export function useAdminContext(): AdminContextResult {
    const [searchParams] = useSearchParams();
    const adminTenantId = searchParams.get("tenantId");
    const adminSuscriptionId = searchParams.get("suscriptionId");
    const isAdminMode = !!adminTenantId;

    const adminQuerySuffix = isAdminMode
        ? `?tenantId=${adminTenantId}&suscriptionId=${adminSuscriptionId ?? ""}`
        : "";

    const profileBackUrl = adminSuscriptionId
        ? `/user/profile/${adminSuscriptionId}`
        : "/user/profile";

    return { adminTenantId, adminSuscriptionId, isAdminMode, adminQuerySuffix, profileBackUrl };
}
